import NuitrackAnalyticsUpgradeBlock from './NuitrackAnalyticsUpgradeBlock';

export default NuitrackAnalyticsUpgradeBlock;
